"use strict";
var from_1 = require('./from');
exports.fromCallback = from_1.default;
var to_1 = require('./to');
exports.toCallback = to_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /root/urbanmassage/node_modules/promise-cb/index.js
// module id = 283
// module chunks = 73